import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { supabase } from '../../supabase';

function PrivateRoute() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check Supabase auth state
    const checkAuth = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (user) {
          setIsAuthenticated(true);
        } else {
          // If Supabase auth fails, check localStorage fallback
          const localAuth = localStorage.getItem('isAdminAuthenticated');
          setIsAuthenticated(localAuth === 'true');
        }
      } catch (error) {
        console.error('Auth check error:', error);
        // Fallback to localStorage check
        const localAuth = localStorage.getItem('isAdminAuthenticated');
        setIsAuthenticated(localAuth === 'true');
      }
      setLoading(false);
    };

    checkAuth();

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (session?.user) {
        setIsAuthenticated(true);
      } else {
        const localAuth = localStorage.getItem('isAdminAuthenticated');
        setIsAuthenticated(localAuth === 'true');
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Loading...</p>
      </div>
    );
  }
  
  // If not authenticated, redirect to admin login page
  if (!isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }

  // If authenticated, render the child routes
  return <Outlet />;
}

export default PrivateRoute; 